<template>
    <div>
        <v-checkbox color="primary" v-model="direct" required label="Navadna pošta" />
        <v-checkbox color="primary" v-model="email" required label="Elektronska pošta" />
        <v-checkbox color="primary" v-model="sms" required label="SMS/MMS obvestila" />
        <v-checkbox color="primary" v-model="call" required label="Telefonski klici" />
        <v-checkbox color="primary" v-model="digital" required label="v digitalnem okolju (splet, družbena omrežja, elektronske naprave v Tuš poslovalnicah, mobilna aplikacija Tuš)" />
        <v-checkbox color="primary" v-model="push" required label="po meri oblikovanao spletno oglaševanje" />
    </div>
</template>

<script>
    import utils from "../store/utils";


    export default {
        name: "ConsentsChannels",
        props: {
            vuex_module: {
                type: String,
                default: 'registration'
            }
        },
        computed: {
            direct: utils.vuexBuildSetGet(this, null, 'consent_channels.direct', null, 'registration/refreshConsent'),
            email: utils.vuexBuildSetGet(this, null, 'consent_channels.email', null, 'registration/refreshConsent'),
            sms: utils.vuexBuildSetGet(this, null, 'consent_channels.sms', null, 'registration/refreshConsent'),
            call: utils.vuexBuildSetGet(this, null, 'consent_channels.call', null, 'registration/refreshConsent'),
            digital: utils.vuexBuildSetGet(this, null, 'consent_channels.digital', null, 'registration/refreshConsent'),
            push: utils.vuexBuildSetGet(this, null, 'consent_channels.push', null, 'registration/refreshConsent')
        }
    }
</script>

<style scoped>

</style>